import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { Todo, Mission } from "@/types/todo";

interface MissionModalProps {
  isOpen: boolean;
  onClose: () => void;
  todo?: Todo;
  missions?: Mission[];
  onChangeMission?: () => void;
  onRemoveMission?: () => void;
}

const MissionModal = ({ 
  isOpen, 
  onClose, 
  todo, 
  missions = [], 
  onChangeMission, 
  onRemoveMission 
}: MissionModalProps) => {
  if (!todo || !todo.missionId) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-left">
          <DialogTitle>Mission</DialogTitle>
        </DialogHeader>
        </DialogContent>
      </Dialog>
    );
  }

  const currentMission = missions.find(m => m.id === todo.missionId);
  if (!currentMission) return null;

  const handleChangeMission = () => {
    onChangeMission?.();
    onClose();
  };

  const handleRemoveMission = () => {
    onRemoveMission?.();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-left">
          <DialogTitle>
            {todo.title} • {currentMission.name}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6">
          <div className="flex flex-col gap-2">
            <Button 
              onClick={onClose}
              className="w-full"
            >
              Continue
            </Button>
            
            <Button 
              onClick={handleChangeMission}
              variant="outline"
              className="w-full"
            >
              Change Mission
            </Button>
            
            <Button 
              onClick={handleRemoveMission}
              variant="ghost"
              className="w-full flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Remove from Mission
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MissionModal;